export default __webpack_public_path__ + "static/media/loader.ddef5cd3.gif";